export const TimeInputComingSoon = () => {
    return (
        <div className={classes.wrap}>
            <div className={classes.title}>Time-Based Search</div>
            <div className={classes.time}>9:00 AM - 12:00 PM</div>
            <div className={classes.comingSoon}>COMING SOON</div>
        </div>
    )
}

const classes = {
    wrap: "relative leading-none pl-3 h-[46px] flex flex-col justify-center w-full border border-gray-300 rounded-[4px] bg-[#f9f9f9] cursor-not-allowed",
    title: "text-[10px] font-bold text-black/20 mb-1",
    time: "text-[14px] font-bold text-black/20",
    comingSoon:
        "absolute right-3 px-1.5 pt-[3px] pb-[3px] inline-block bg-black rounded-full text-white text-[10px] text-white",
}
